import { Alert as AntdAlert } from 'antd';
import styled from 'styled-components';

export const BaseAlert = styled(AntdAlert)`
  padding: 12px 20px;

  &.ant-alert-info {
    border: none;
    background-color: #f2f1fe;

    .ant-alert-message,
    .anticon-info-circle {
      color: #8277f8;
    }
  }

  text-align: center;
`;
